import React, { useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';

import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from 'reactstrap';

import Select from 'react-select';

import FieldError from '../../../../../helper/FieldError';

import { inputId, inputName } from '../../../../../helper/form';

import LaboralBulkLoadAraucoDocxMergeFieldFormList from './form_list';

const getMetadataFileTemplateService = async (file) => {
  let formData = new FormData();
  formData.append('template_file', file);

  const response = await axios({
    method: 'post',
    url: Routes.metadata_file_template_laboral_bulk_load_arauco_docx_merge_fields_path({ 'format': 'json' }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token
    }
  })

  return response;
}

const getMetadataFileDataService = async (file) => {
  let formData = new FormData();
  formData.append('data_file', file);

  const response = await axios({
    method: 'post',
    url: Routes.metadata_file_data_laboral_bulk_load_arauco_docx_merge_fields_path({ 'format': 'json' }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token
    }
  })

  return response;
}

const createDocxMergeFieldService = async (formData) => {
  const response = await axios({
    method: 'post',
    url: Routes.laboral_bulk_load_arauco_docx_merge_fields_path({ 'format': 'json' }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token
    }
  })

  return response;
}

const getFormData = (formName, bulkLoad) => {
  let formData = new FormData();

  formData.append(`${formName}[template_file]`, bulkLoad.template_file);
  formData.append(`${formName}[data_file]`, bulkLoad.data_file);
  formData.append(`${formName}[document_type_id]`, bulkLoad.document_type_id || '');
  formData.append(`${formName}[label]`, bulkLoad.label || '');

  _.each(bulkLoad.associatedMergeFields, (associatedMergeField) => {
    formData.append(`${formName}[associated_merge_fields][${associatedMergeField.mergeField}]`, associatedMergeField.header || '');
  });

  return formData;
}

const LaboralBulkLoadAraucoDocxMergeFieldForm = props => {
  const formName = 'docx_merge_field';

  const { data } = props;

  const {
    allowedTemplateFileFormats,
    allowedDataFileFormats,
  } = data;

  const [processedFiles, setProcessedFiles] = useState({
    templateFile: {
      mergeFields: []
    }
  });
  const [bulkLoad, setBulkLoad] = useState({
    associatedMergeFields: []
  });

  const onChangeBulkLoad = (key, event) => {
    let _bulkLoad = { ...bulkLoad };
    let value = event.target.value;

    if (event.target.type == 'file') {
      value = event.target.files[0];
    }

    _bulkLoad[key] = value;

    setBulkLoad(prevState => {
      return { ...prevState, ..._bulkLoad }
    })
  }

  // ========== START DOCUMENT TYPE SELECT ==========
  const documentTypeSelectOptions = useMemo(() => {
    return _.map(props?.data?.documentTypes || [], documentType => ({ value: documentType.id, label: documentType.name }))
  }, [props?.data?.documentTypes])

  const documentTypeSelectedOption = useMemo(() => {
    return _.find(documentTypeSelectOptions, { value: bulkLoad?.document_type_id })
  }, [bulkLoad?.document_type_id, documentTypeSelectOptions])

  const documentTypeInputSelect = () => {
    return (
      <FormGroup>
        <FieldError errors={_.get(bulkLoad, 'errors.document_type') || []}>
          <Label className='required' htmlFor={inputId(formName, 'document_type_id')}>
            {I18n.t('activerecord.attributes.laboral/bulk/load/arauco/docx_merge_field.document_type')}
          </Label>

          <Select
            id={inputId(formName, 'document_type_id')}
            name={inputName(formName, 'document_type_id')}
            invalid={_.has(bulkLoad?.errors, 'document_type')}
            value={documentTypeSelectedOption}
            onChange={e => onChangeBulkLoad('document_type_id', { target: { value: e?.value } })}
            options={documentTypeSelectOptions}
            isClearable={true}
            placeholder={`-- Selecciona un ${I18n.t('activerecord.attributes.laboral/bulk/load/arauco/docx_merge_field.document_type')} --`}
          />

        </FieldError>
      </FormGroup>
    )
  }
  // ========== END DOCUMENT TYPE SELECT ==========
  // ==================================================
  // ========== START LABEL ==========
  const labelInput = () => {
    return (
      <FormGroup>
        <FieldError errors={_.get(bulkLoad, 'errors.label') || []}>
          <Label htmlFor={inputId(formName, 'label')}>
            {I18n.t('activerecord.attributes.laboral/bulk/load/arauco/docx_merge_field.label')}
          </Label>
          <Input
            type='text'
            id={inputId(formName, 'label')}
            name={inputName(formName, 'label')}
            invalid={_.has(bulkLoad?.errors, 'label')}
            value={bulkLoad?.label || ''}
            onChange={event => onChangeBulkLoad('label', event)}
          />
        </FieldError>
      </FormGroup>
    )
  }
  // ========== END LABEL ==========
  // ==================================================
  // ========== START TEMPLATE FILE ==========
  const docxFileInput = () => {
    return (
      <FormGroup>
        <FieldError errors={_.get(bulkLoad, 'errors.template_file') || []}>
          <Label className='required' htmlFor={inputId(formName, 'template_file')}>
            {I18n.t('activerecord.attributes.laboral/bulk/load/arauco/docx_merge_field.template_file')}
          </Label>
          <Input
            type='file'
            id={inputId(formName, 'template_file')}
            name={inputName(formName, 'template_file')}
            accept={allowedTemplateFileFormats.map(format => format.extension).join(',')}
            invalid={_.has(bulkLoad?.errors, 'template_file')}
            onChange={event => onChangeBulkLoad('template_file', event)}
          />
        </FieldError>
      </FormGroup>
    )
  }

  const onGetMetadataFileTemplate = useCallback(async (file) => {
    const response = await getMetadataFileTemplateService(file);
    return response;
  }, []);

  useEffect(() => {
    if (bulkLoad.template_file) {
      onGetMetadataFileTemplate(bulkLoad.template_file).then(response => {
        if (response.status == 200) {
          setProcessedFiles(prevState => {
            return {
              ...prevState,
              templateFile: {
                mergeFields: response.data.merge_fields
              }
            }
          })
        } else {
          swal.fire({
            icon: 'error',
            title: 'Error al obtener datos de la plantilla',
            text: response.data.error,
          })
        }
      })
    }
  }, [bulkLoad.template_file]);
  // ========== END TEMPLATE FILE ==========
  // ==================================================
  // ========== START DATA FILE ==========
  const xlsxFileInput = () => {
    return (
      <FormGroup>
        <FieldError errors={_.get(bulkLoad, 'errors.data_file') || []}>
          <Label className='required' htmlFor={inputId(formName, 'data_file')}>
            {I18n.t('activerecord.attributes.laboral/bulk/load/arauco/docx_merge_field.data_file')}
          </Label>
          <Input
            type='file'
            id={inputId(formName, 'data_file')}
            name={inputName(formName, 'data_file')}
            invalid={_.has(bulkLoad?.errors, 'data_file')}
            accept={allowedDataFileFormats.map(format => format.extension).join(',')}
            onChange={event => onChangeBulkLoad('data_file', event)}
          />
        </FieldError>
      </FormGroup>
    )
  }

  const onGetHeadersDataFile = useCallback(async (dataFile) => {
    const response = await getMetadataFileDataService(dataFile)
    return response;
  }, []);

  useEffect(() => {
    if (bulkLoad.data_file) {
      onGetHeadersDataFile(bulkLoad.data_file).then(response => {
        if (response.status == 200) {
          setProcessedFiles(prevState => {
            return {
              ...prevState,
              dataFile: {
                headers: response.data.headers
              }
            }
          })
        }
      }).catch(error => {
        swal.fire({
          icon: 'error',
          title: 'Error al obtener datos del archivo',
          text: error.response.data.error,
        })
      })
    }
  }, [bulkLoad.data_file]);
  // ========== END DATA FILE ==========

  // ========== START PROCESS FILES ==========
  const canProcessFiles = () => {
    return (processedFiles?.templateFile?.mergeFields || []).length > 0 && (processedFiles?.dataFile?.headers || []).length > 0;
  }

  const associateHeadersWithMergeFields = useCallback((mergeFields, headers) => {
    return mergeFields.map(mergeField => {
      const header = headers.find(header => _.lowerCase(header) === _.lowerCase(mergeField));

      return {
        mergeField: mergeField,
        header: header,
        associated: header ? true : false
      }
    })
  }, []);

  useEffect(() => {
    if (!canProcessFiles()) return;

    let associatedMergeFields = associateHeadersWithMergeFields(processedFiles.templateFile.mergeFields, processedFiles.dataFile.headers);

    setBulkLoad(prevState => {
      return {
        ...prevState,
        associatedMergeFields: associatedMergeFields
      }
    })
  }, [processedFiles])
  // ========== END PROCESS FILES ==========

  const associatedMergeFieldWithHeader = useMemo(() => {
    return bulkLoad.associatedMergeFields.filter(associatedMergeField => associatedMergeField.associated);
  }, [bulkLoad.associatedMergeFields])

  const associatedMergeFieldWithoutHeader = useMemo(() => {
    return bulkLoad.associatedMergeFields.filter(associatedMergeField => !associatedMergeField.associated);
  }, [bulkLoad.associatedMergeFields])

  // ========== START MEMOIZED ==========
  const memoizedData = useMemo(() => ({
    headers: processedFiles?.dataFile?.headers || [],
    systemOptions: props?.data?.systemOptions || []
  }), [processedFiles?.dataFile?.headers]);

  const memoizedCallbacks = useMemo(() => ({
    onSetBulkLoadCallback: setBulkLoad
  }), []);
  // ========== END MEMOIZED ==========

  // ========== START SUBMIT FORM ==========

  const onConfirmSubmit = (event) => {
    event.preventDefault();
    swalWithBootstrap.fire({
      title: `${I18n.t('actions.save')} ${I18n.t('activerecord.models.laboral/bulk/load/arauco/docx_merge_field.one')}`,
      html: '¿Estás seguro de realizar la carga de documentos?',
    }).then(result => {
      if (result.isConfirmed) {
        onSubmit()
      }
    })
  }

  const onSubmit = () => {
    let formData = getFormData(formName, bulkLoad);

    createDocxMergeFieldService(formData).then(response => {
      if (response.status == 201) {
        window.location.href = Routes.laboral_bulk_load_arauco_docx_merge_field_path({ id: response.data.hashid });
      }
    }).catch(error => {
      if (error.response.status == 422) {
        setBulkLoad(prevState => {
          return {
            ...prevState,
            errors: error.response.data.errors
          }
        })
      }

      swalToastBootstrap.fire({
        icon: 'error',
        title: I18n.t('errors.unprocessable_content')
      });
    })
  }
  // ========== END SUBMIT FORM ==========

  return (
    <Form onSubmit={onConfirmSubmit}>
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              {documentTypeInputSelect()}
              {labelInput()}
              {docxFileInput()}
              {xlsxFileInput()}

              {function () {
                if (associatedMergeFieldWithoutHeader.length > 0) {
                  return (
                    <LaboralBulkLoadAraucoDocxMergeFieldFormList
                      associatedMergeFields={associatedMergeFieldWithoutHeader}
                      data={memoizedData}
                      callbacks={memoizedCallbacks}
                      errors={bulkLoad.errors}
                    />
                  )
                }
              }()}

              {function () {
                if (associatedMergeFieldWithHeader.length > 0) {
                  return (
                    <LaboralBulkLoadAraucoDocxMergeFieldFormList
                      associatedMergeFields={associatedMergeFieldWithHeader}
                      data={memoizedData}
                      callbacks={memoizedCallbacks}
                      errors={bulkLoad.errors}
                    />
                  )
                }
              }()}
            </CardBody>
          </Card>

          <div className="text-end">
            <a
              href={Routes.laboral_bulk_load_arauco_docx_merge_fields_path()}
              className='btn btn-default'
            >
              {I18n.t('actions.back')}
            </a>

            <Button
              color='success'
              className='ml-2'
              type='submit'
            >
              {I18n.t('actions.save')}
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
};

export default LaboralBulkLoadAraucoDocxMergeFieldForm;
